import { useOnboardingPaymentMethods } from "ui/organizms/ECommerce/Onboarding/common";
import { Merchant } from "ui/forms/ECommerce";
import { useOnboardingApplication } from "../../hooks";

export const usePaymentMethods = () => {
    const { getApplicationModel } = useOnboardingApplication();

    const {
        paymentMethods,
        getPaymentMethods,
        fromPaymentMethodsInitialValues,
        toRequestPaymentMethods,
        withValues,
        ...data
    } = useOnboardingPaymentMethods({
        getApplicationModel
    });

    const formProps: Merchant.PaymentMethods.OnboardingPaymentMethodsForm = {
        isBootstrapDataLoading: false,
        bootstrapData: {
            methods: getPaymentMethods()
        },
        initialValues: Merchant.PaymentMethods.getInitialValues(
            fromPaymentMethodsInitialValues()
        ),
        onSaveOrCreate: async ({
            methods = []
        }, helpers) => (
            withValues({
                methods: toRequestPaymentMethods(methods)
            }, helpers)
        )
    };

    return {
        ...formProps,
        ...Merchant.PaymentMethods.useForm(formProps),
        ...data
    };
};

export default usePaymentMethods;
